export enum ErrorCodes {
  ValidationError,
  UserExists,
  NotFound,
  Unauthorized,
  InvalidToken,
  OrganizationDataNeeded,
  SomethingWentWrong,
  TooManyRequests,
}
